import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { ProductListDemo } from '../../../../data';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { handleGetProductOpe } from './ProductOperation';

const ProductSettingContext = createContext();

export const useProductSetting = () => useContext(ProductSettingContext);

function ProductSettingProvider({ children }) {
    const { setMessage } = useTemplate();
    const [reloadKey, setReloadKey] = useState(0);
    const [createProductModal, setCreateProductModal] = useState(false);
    const [productData, setProductData] = useState(ProductListDemo || {});
    const [products, setProducts] = useState(productData.applicationList);
    const [productFilter, setProductFilter] = useState({
        searchValue: '',
        status: ''
    });

    useEffect(() => {
        setProductData(ProductListDemo);
        setProducts(ProductListDemo?.applicationList);
        handleGetProductOpe()
            .then(({ data }) => {
                setProductData(data);
                setProducts(data?.applicationList);
            })
            .catch((err) => {
                setProductData({ applicationList: [] });
                setProducts([]);
                setMessage({ type: 'error', text: err.toString(0) });
            });
    }, [reloadKey, setMessage]);

    const valueCtx = useMemo(() => {
        // --Handle Reload
        const handleReload = () => {
            setReloadKey((d) => d + 1);
        };
        // Create new customer modal show/hide handler
        const handleShowCreateModal = () => setCreateProductModal(true);

        return {
            reloadKey,
            setReloadKey,
            handleReload,
            products,
            setProducts,

            // -- Product Data
            productData,

            // -- create modal
            createProductModal,
            setCreateProductModal,
            handleShowCreateModal,

            productFilter,
            setProductFilter
        };
    }, [createProductModal, productData, products, reloadKey, productFilter, setProductFilter]);

    return (
        <ProductSettingContext.Provider value={valueCtx}>{children}</ProductSettingContext.Provider>
    );
}

export default ProductSettingProvider;
